import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F6FAF9]">
        <div className="flex items-center gap-3 text-teal-700">
          <Loader2 className="animate-spin" size={22} />
          <span className="font-cairo">جاري التحقق من الجلسة...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && user.role !== "super_admin" && !allowedRoles.includes(user.role)) {
    return (
      <div className="p-8" data-testid="forbidden">
        <div className="max-w-md mx-auto bg-white border border-rose-200 rounded-2xl p-6 text-center">
          <div className="font-cairo text-xl font-bold text-rose-700 mb-2">ليس لديك الصلاحية</div>
          <p className="text-slate-600 text-sm">دورك الحالي لا يسمح بالوصول إلى هذه الصفحة.</p>
        </div>
      </div>
    );
  }

  return children;
}
